export const CHANGE_REVIEW_TIMEOUT_MS = 5 * 60_000;

export type PublishedChange = {
  title: string;
  before: string;
  after: string;
  paths: string[];
  discussionEntryId: string | null;
};

export type PublishedChangeReview = {
  commitId: string;
  baseCommitId: string | null;
  status: "generating" | "complete" | "error";
  summary: string;
  changes: PublishedChange[];
};

export function publishedChangeReviewContext(review: PublishedChangeReview) {
  if (review.status !== "complete") return null;
  return `The draft started from published commit ${review.commitId}. This is historical context, not a new request. Use readVersionChat with this commitId to read the discussion when needed.\n${JSON.stringify({ summary: review.summary, changes: review.changes })}`;
}
